module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-arrow-dark-new-e033db960e66a9e1594239f7747e2349.svg";